const setVariantBundle = (variantId) => {
  const form = document.querySelector('.product-single__form');
  if (!form || !window.variantBundleDiscount?.[variantId]) return;

  const discountName = window.variantBundleDiscount[variantId].name;
  const bulkBundleDiscountName = form.querySelector('input[name="properties[_bulk_bundle_discount_name]"]');

  if (discountName) {
    if (!bulkBundleDiscountName) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_bulk_bundle_discount_name]';
      input.value = discountName;
      form.appendChild(input);
    } else {
      bulkBundleDiscountName.value = discountName;
    }
  } else {
    if (bulkBundleDiscountName) bulkBundleDiscountName.remove();
  }
};

document.addEventListener('variant:change', function({ detail }) {
  setVariantBundle(detail.variant.id);
});

window.addEventListener('load', function() {
  const idInput = document.querySelector('.product-single__form [name="id"]');
  if (idInput) setVariantBundle(parseInt(idInput.value));
});
